import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const SubHeaderWrapper = styled.div``

export const SubHeaderNavList = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`

export const SubHeaderNavListItem = styled.li`
  padding: 0px; 
`

export const SubHeaderNavListLink = styled(NavLink)`
  position: relative;
  display: block;
  padding: 0 10px 10px 10px;
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  transition: .3s;
  border-bottom: 3px solid ${({ theme }) => theme.colors.brand}00;

  // TODO: Use theme mixins
  &.active {
    font-weight: 600;
  }

  &.active,
  &:hover {
    color: ${({ theme }) => theme.colors.brand};

    border-bottom: 3px solid ${({ theme }) => theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme }) => theme.colors.primary};
`
